import styles from './index.module.scss';
import {useParams} from "react-router";
import {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../../../hooks";
import {loadInvestment} from "../../../../features/myInvestments/actions/loadInvestment";
import InvestmentDetails from "./InvestmentDetails";
import InvestmentDocuments from "./InvestmentDocuments";
import PaymentSchedule from "./PaymentSchedule";
import ProjectDetails from "./ProjectDetails";
import {RejectedMessage} from "../../../../componets/ui";

export default function ViewInvestment() {
	const { investmentId = '' } = useParams();
	const dispatch = useAppDispatch();
	const { investment = {}, status } = useAppSelector((state) => state.myInvestments);
	const isEmpty = investment.currentInvestmentSchedule?.length === 0
	useEffect(() => {
		dispatch(loadInvestment(Number(investmentId)));
	}, []);
	if (status === 'rejected') {
		return (
			<RejectedMessage isNotFound={true} />
		);
	}
	return (
		<div className={styles.root}>
			<div className={`${styles.content}`}>
				{investment?.currentInvestmentSchedule && investment?.archiveInvestmentSchedule && (
					<PaymentSchedule
						data={investment.currentInvestmentSchedule}
						archive={investment.archiveInvestmentSchedule}
						notes={[]}
					/>
				)}
				{isEmpty && (
					<div className={styles.bottomBar}>
						<InvestmentDetails
							loading={status === 'pending'}
							data={investment}
						/>
						<InvestmentDocuments
							agreements={investment?.agreements}
							row={investment.investment}
							loading={status === 'pending'}
						/>
					</div>
				)}
			</div>
			<div className={styles.sidebar}>

				{investment?.project && (
					<div className={styles.col}>
						<ProjectDetails item={investment.project} />
					</div>
				)}
				{!isEmpty && (
					<div className={styles.col}>
						<InvestmentDetails
							loading={status === 'pending'}
							data={investment}
						/>
						<InvestmentDocuments
							agreements={investment?.agreements}
							row={investment.investment}
							loading={status === 'pending'}
						/>
					</div>
				)}
			</div>
		</div>
	)
}
